import { isManagerCancelledShift } from "./attendanceCoverage";

// Shifts a person works at the company's other stores arrive alongside this
// store's schedule, one row per shift. A day can hold several, at one store or
// across several, so every surface lists them all rather than the first.

export function sortOtherStoreShifts(shifts) {
  return [...(Array.isArray(shifts) ? shifts : [])]
    .filter(Boolean)
    .sort((a, b) => (a.shift_start ?? 0) - (b.shift_start ?? 0));
}

export function otherStoreShiftLabel(shift, getTime) {
  const store = shift?.store_name || "Other store";
  if (shift?.times_unknown) return `@ ${store}`;
  return `${getTime(shift?.shift_start)} - ${getTime(shift?.shift_end)} @ ${store}`;
}

// The other-store shifts that share time with any of this store's shifts.
// Same rule as the time-off conflict check: start < other end AND end > other
// start, so back-to-back shifts do not count. A shift the manager cancelled
// was never going to be worked, so it cannot clash on either side.
export function getOverlappingOtherStoreShifts(ownShifts, otherStoreShifts) {
  const own = (Array.isArray(ownShifts) ? ownShifts : []).filter(
    (shift) =>
      shift && !shift.times_unknown && !isManagerCancelledShift(shift)
  );
  return sortOtherStoreShifts(otherStoreShifts).filter(
    (other) =>
      !other.times_unknown &&
      !isManagerCancelledShift(other) &&
      own.some(
        (shift) =>
          shift.shift_start < other.shift_end &&
          shift.shift_end > other.shift_start
      )
  );
}
